import { OperatorFunction } from 'rxjs';
import { map } from 'rxjs/operators';
import { isArray } from '@shared/functions/is-array';
import { Page } from '@shared/models/pagination';

export function parseHttpResponseList<T, R>(model?: any): OperatorFunction<T[], R[]> {
    if (typeof model !== 'function') {
        throw TypeError(`${model} is not of type ctor.`);
    }

    return map((items: T[]) => isArray(items) ? items.map((item) => new model(item)) as R[] : []);
}

export function parseHttpResponseItem<T, R>(model: any): OperatorFunction<T, R> {
    if (typeof model !== 'function') {
        throw TypeError(`${model} is not of type ctor.`);
    }

    return map((item: T) => item ? new model(item) as R : undefined);
}

export function normalizeHttpResponsePage<T>(response: Page<T> | T[]): Page<T> {
    if (isArray(response)) {
        const items = response as T[];

        return {
            results: items,
            total: items.length,
            page: 0,
            size: items.length,
        };
    }

    const page = response as Page<T>;

    return {
        ...page,
        results: page?.results ?? [],
    };
}

export function parseHttpResponsePage<T, R>(model?: any): OperatorFunction<Page<T> | T[], Page<R>> {
    if (typeof model !== 'function') {
        throw TypeError(`${model} is not of type ctor.`);
    }

    return map((response: Page<any> | any[]) => {
        const page = normalizeHttpResponsePage(response);

        if (isArray(page.results)) {
            page.results = page.results.map((item) => new model(item) as R);
        }

        return page as Page<R>;
    });
}
